var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    height: "2.22rem",
    width: "2.22rem",
    alt: "Immediate Attention Icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eApproval_Alert_",
    "data-name": "eApproval_Alert"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,48.75a6.27,6.27,0,0,1-6.06-6.21,1,1,0,0,0-1-1H3.81A.94.94,0,0,1,2.92,41a.87.87,0,0,1,.16-1l5.37-5.94A5.85,5.85,0,0,0,10,30.17V21.29A14.81,14.81,0,0,1,22.2,6.82a1,1,0,0,0,.82-1V3.23a2,2,0,0,1,4,0V5.85a1,1,0,0,0,.82,1A15.13,15.13,0,0,1,40,21.73v8.44a5.85,5.85,0,0,0,1.51,3.9L46.92,40a.87.87,0,0,1,.16,1,.94.94,0,0,1-.89.57H32.06a1,1,0,0,0-1,1A6.27,6.27,0,0,1,25,48.75Zm-4.09-8a1.5,1.5,0,0,0-1.5,1.5,5.56,5.56,0,0,0,5.42,5.55,1.5,1.5,0,1,0,0-3,2.59,2.59,0,0,1-2.42-2.55A1.5,1.5,0,0,0,20.91,40.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,2.25a1,1,0,0,1,1,1V5.85a2,2,0,0,0,1.63,2A14.14,14.14,0,0,1,39,21.73v8.44a6.82,6.82,0,0,0,1.77,4.57l5.25,5.81h-14a2,2,0,0,0-2,2,5.5,5.5,0,0,1-2.88,4.67,2.36,2.36,0,0,0,.15-.84,2.5,2.5,0,0,0-2.5-2.5,1.59,1.59,0,0,1-1.42-1.55,2.51,2.51,0,0,0-2.5-2.5,2.48,2.48,0,0,0-2,1,2,2,0,0,0-1-.25h-14l5.25-5.81A6.82,6.82,0,0,0,11,30.17V21.29A13.82,13.82,0,0,1,22.38,7.8a2,2,0,0,0,1.64-2V3.23a1,1,0,0,1,1-1m0-2a3,3,0,0,0-3,3V5.84A15.81,15.81,0,0,0,9,21.29v8.88A4.84,4.84,0,0,1,7.71,33.4L2.34,39.34a1.92,1.92,0,0,0,1.47,3.21H17.94A7.31,7.31,0,0,0,25,49.75a7.31,7.31,0,0,0,7.06-7.2H46.19a1.92,1.92,0,0,0,1.47-3.21L42.29,33.4A4.84,4.84,0,0,1,41,30.17V21.73A16.19,16.19,0,0,0,28,5.85V3.23a3,3,0,0,0-3-3Zm-.17,46.6a4.55,4.55,0,0,1-4.42-4.55.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5,3.58,3.58,0,0,0,3.42,3.55.5.5,0,0,1,.5.5.51.51,0,0,1-.5.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertBell);
export default __webpack_public_path__ + "static/media/AlertBell.4e1e4f46.svg";
export { ForwardRef as ReactComponent };